import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn'
import enUS from '@arco-design/web-vue/es/locale/lang/en-us'
import jaJP from '@arco-design/web-vue/es/locale/lang/ja-jp'

// 自定义英文语言包
const customEnUS = {
  ...enUS,
  pagination: {
    ...enUS.pagination,
    goto: 'Go to'
  }
}

// 自定义日文语言包
const customJaJP = {
  ...jaJP,
  pagination: {
    ...jaJP.pagination,
    goto: 'ジャンプ'
  }
}

// 语言标识与 Arco UI 语言包映射
const localeMap = {
  'zh-CN': zhCN,
  'en-US': customEnUS,
  'ja-JP': customJaJP
}

/**
 * 根据当前语言获取 Arco UI 语言包
 * @param {string} lang - 语言标识 zh-CN / en-US / ja-JP
 */
export const getArcoLocale = (lang) => localeMap[lang] || customEnUS

